import { render } from "./BioThree.vue?vue&type=template&id=079efd9e"
import script from "./BioThree.vue?vue&type=script&lang=js"
export * from "./BioThree.vue?vue&type=script&lang=js"

import "./BioThree.vue?vue&type=style&index=0&id=079efd9e&lang=css"
script.render = render

export default script